import styled from 'styled-components';

export const Container = styled.div`
  margin: 71px 105px;
`;
